module.exports = __webpack_public_path__ + "media/images/iconSocialFacebook--dark-7872f01f2f37b324587f8cddeff053d4.png";